import React, { useState } from 'react';
import { FileText, Send } from 'lucide-react';
import axios from 'axios';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue } from
'./ui/select';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const GetQuote = () => {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    beltWidth: '',
    beltType: '',
    requirements: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleBeltTypeChange = (value) => {
    setFormData({
      ...formData,
      beltType: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await axios.post(`${API}/quote`, formData);
      
      if (response.data.success) {
        toast.success(response.data.message);
        // Reset form
        setFormData({
          name: '',
          company: '',
          email: '',
          phone: '',
          beltWidth: '',
          beltType: '',
          requirements: ''
        });
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error('Error submitting quote:', error);
      toast.error('Failed to submit quote request. Please try again or contact us directly.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="quote" className="py-16 md:py-24 bg-slate-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Get a Quote
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
        </div>

        <div className="bg-blue-50 border-l-4 border-blue-600 p-6 rounded-lg mb-8">
          <div className="flex items-start gap-3">
            <FileText className="text-blue-600 flex-shrink-0 mt-1" size={24} />
            <div>
              <h3 className="font-semibold text-slate-900 mb-2">Information Required for Quote:</h3>
              <ul className="text-slate-700 space-y-1">
                <li>• Belt Width in mm</li>
                <li>• Type of belt: Fabric or Steel Cord</li>
                <li>• In case of fabric: Belt rating as specified by Conveyor belt manufacturer</li>
                <li>• In case of steel cord belt: ST rating as specified by the conveyor belt manufacturer</li>
              </ul>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="bg-white p-6 md:p-8 rounded-lg shadow-lg space-y-6">
          <div className="grid sm:grid-cols-2 gap-6">
            <div className="space-y-2">
              <Label htmlFor="name">Name *</Label>
              <Input
                id="name"
                name="name"
                type="text"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Your full name"
                className="border-slate-300" />

            </div>

            <div className="space-y-2">
              <Label htmlFor="company">Company Name *</Label>
              <Input
                id="company"
                name="company"
                type="text"
                value={formData.company}
                onChange={handleChange}
                required
                placeholder="Your company name"
                className="border-slate-300" />

            </div>
          </div>

          <div className="grid sm:grid-cols-2 gap-6">
            <div className="space-y-2">
              <Label htmlFor="email">Email *</Label>
              <Input
                id="email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="your@email.com"
                className="border-slate-300" />

            </div>

            <div className="space-y-2">
              <Label htmlFor="phone">Phone Number *</Label>
              <Input
                id="phone"
                name="phone"
                type="tel"
                value={formData.phone}
                onChange={handleChange}
                required
                placeholder="+91-XXX-XXX-XXXX"
                className="border-slate-300" />

            </div>
          </div>

          <div className="grid sm:grid-cols-2 gap-6">
            <div className="space-y-2">
              <Label htmlFor="beltWidth">Belt Width (mm) *</Label>
              <Input
                id="beltWidth"
                name="beltWidth"
                type="text"
                value={formData.beltWidth}
                onChange={handleChange}
                required
                placeholder="e.g., 1200"
                className="border-slate-300" />

            </div>

            <div className="space-y-2 !opacity-[0%]">
              <Label htmlFor="beltType">Belt Type *</Label>
              <Select value={formData.beltType} onValueChange={handleBeltTypeChange} required>
                <SelectTrigger className="border-slate-300">
                  <SelectValue placeholder="Select belt type" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="fabric">Fabric</SelectItem>
                  <SelectItem value="steel-cord">Steel Cord</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="requirements">Additional Requirements *</Label>
            <Textarea
              id="requirements"
              name="requirements"
              value={formData.requirements}
              onChange={handleChange}
              required
              placeholder="Please specify belt rating (for fabric) or ST rating (for steel cord) and any other requirements..."
              rows={5}
              className="border-slate-300" />

          </div>

          <Button
            type="submit"
            disabled={isSubmitting}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-6 text-lg font-semibold">

            {isSubmitting ?
            'Submitting...' :

            <>
                <Send size={20} className="mr-2" />
                Submit Quote Request
              </>
            }
          </Button>
        </form>
      </div>
    </section>);

};